export default __webpack_public_path__ + "static/media/chevron.da3feddf.svg";